import  { ReactNode, useState } from "react";
import styles from "./statisticFormat.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { CiFilter } from "react-icons/ci";
import AllDataFilterPopup from "pages/statistic/statisticPopup/allDataFilterPopup";

interface StatisticTabbarProps {
    label: string;
    description: string;
    children: ReactNode;
    onFilterButton1Click?: () => void;
    onButton1Click: (label: string, description: string) => void;
}

export default function StatisticTabbar({
    label,
    description,
    children,
    onFilterButton1Click,
    onButton1Click,

}: StatisticTabbarProps) {
    const [isAllDataFilterPopupOpen, setIsAllDataFilterPopupOpen] = useState(false);

    return (
        <>
            <AllDataFilterPopup isPopupOpen={isAllDataFilterPopupOpen} onClose={() => setIsAllDataFilterPopupOpen(false)} />

            <div className={styles.StatisticFormatContainer}>
                <div className={styles.statistikContaint}>
                    <div className={styles.headerRow}>
                        <span className={styles.description}>{description}</span>
                        <span className={styles.label}>{label}
                        </span>
                    </div>

                    <div className={styles.statChildContainer}>{children}</div>
                </div>



                <div className={styles.buttonsContainer}>
                    {onFilterButton1Click && <button
                        className={`${commonStyles.commonButton} ${styles.button}`}
                        onClick={() => onFilterButton1Click()}
                    >
                        <CiFilter />Filter
                    </button>}
                    <button
                        className={`${commonStyles.commonButton} ${styles.button}`}
                        onClick={() => onButton1Click(label, description)}
                    >
                        Auswertung herunterladen
                    </button>
                    <button className={`${commonStyles.commonButton} ${styles.button}`}
                        onClick={() => setIsAllDataFilterPopupOpen(true)}

                    >
                        Alle Daten herunterladen
                    </button>
                </div>
            </div>
        </>
    );
}
